import { format } from 'date-fns';
import { toCamelCase } from '../functions';
import i18n from '../../plugins/i18n';

const keyToTranslatorMap = {
  alt_business_id: i18n.tc('brands.labels.altBusinessId'),
  alt_business_id_type: i18n.tc('brands.labels.altBusinessIdType'),
  api_key: i18n.tc('brands.labels.apiKey'),
  display_name: i18n.tc('brands.labels.displayName'),
  company_name: i18n.tc('brands.labels.companyName'),
  website: i18n.tc('brands.labels.website'),
  entity_type: i18n.tc('brands.labels.entityType'),
  postal_code: i18n.tc('brands.labels.postalCode'),
  stock_exchange: i18n.tc('brands.labels.stockExchange'),
  phone_number: i18n.tc('brands.labels.phone'),
  phone: i18n.tc('brands.labels.phone'),
  stock_symbol: i18n.tc('brands.labels.stockSymbol'),
  ein: i18n.tc('brands.labels.ein'),
  altBusinessId: i18n.tc('brands.labels.altBusinessId'),
  altBusinessIdType: i18n.tc('brands.labels.altBusinessIdType'),
  apiKey: i18n.tc('brands.labels.apiKey'),
  displayName: i18n.tc('brands.labels.displayName'),
  companyName: i18n.tc('brands.labels.companyName'),
  entityType: i18n.tc('brands.labels.entityType'),
  postalCode: i18n.tc('brands.labels.postalCode'),
  stockExchange: i18n.tc('brands.labels.stockExchange'),
  phoneNumber: i18n.tc('brands.labels.phone'),
  stockSymbol: i18n.tc('brands.labels.stockSymbol'),
};

const getRegistrationDate = datetime => {
  return datetime ? format(datetime, 'DD MMMM YYYY') : '';
};

const handleBrandCreationErrors = errors => {
  if (!errors || typeof errors !== 'object') {
    return errors;
  }
  if (errors.null) {
    if (errors.null.includes('TCR')) return 'brands.tcrErrorSubstitute';
    return errors.null;
  }
  return Object.keys(errors).reduce((acc, curr) => {
    const splitted = `${errors[curr]}`.split(' ');
    const replaced = splitted.map(word => keyToTranslatorMap[word] || word).join(' ');
    return { ...acc, [toCamelCase(curr)]: replaced };
  }, {});
};

const changeEmptyValuesToNull = brand => ({
  ...brand,
  altBusinessId: brand.altBusinessId || null,
  altBusinessIdType: brand.altBusinessIdType || null,
});

export { getRegistrationDate, handleBrandCreationErrors, changeEmptyValuesToNull };
